var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExclamation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 12,
    viewBox: "0 0 2 12",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.67676 0.818182L1.57733 8.13636H0.423917L0.324485 0.818182H1.67676ZM1.00062 11.0795C0.755356 11.0795 0.544892 10.9917 0.369229 10.8161C0.193567 10.6404 0.105735 10.4299 0.105735 10.1847C0.105735 9.93939 0.193567 9.72893 0.369229 9.55327C0.544892 9.3776 0.755356 9.28977 1.00062 9.28977C1.24589 9.28977 1.45635 9.3776 1.63201 9.55327C1.80768 9.72893 1.89551 9.93939 1.89551 10.1847C1.89551 10.3471 1.85408 10.4962 1.77122 10.6321C1.69167 10.768 1.58395 10.8774 1.44806 10.9602C1.31549 11.0398 1.16634 11.0795 1.00062 11.0795Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.c852f0885940893a9fe3545b82fca4ac.svg";
export { ForwardRef as ReactComponent };